class USP extends HTMLElement {
  constructor() {
    super();
    this.uspSlides = document.querySelectorAll('#usp-slider .keen-slider__slide');
    if (this.uspSlides.length > 1) this.createSlider();
  }

  createSlider() {
    var animation = { duration: 35000, easing: (t) => t }

    var slider = new KeenSlider("#usp-slider", {
      breakpoints: {
        '(min-width: 990px)': {
          disabled: true,
        }
      },
      loop: true,
      slides: {
        perView: "auto",
        spacing: 24
      },
      renderMode: "performance",
      drag: false,
      created(s) {
        s.moveToIdx(5, true, animation)
      },
      updated(s) {
        s.moveToIdx(s.track.details.abs + 5, true, animation)
      },
      animationEnded(s) {
        s.moveToIdx(s.track.details.abs + 5, true, animation)
      },
    })
  }
}

customElements.define('usp-section', USP);